import Vue from "vue";

/**
 * Class S3Service
 */
export default class S3Service extends Vue {
    private customActions = {
        getUrlUpload: { method: 'POST', url: 'integration/s3/urlAuthentication' }
    };

    private resource: any = this.$resource('integration/', {}, this.customActions);

    //GET the authentication url
    public getUrlUpload(data: any) {
      const fileName = data.userName || data.fileName || data.userId;
      const file = fileName + data.extension;

      let param = {
          Bucket: data.bucket,
          Key: data.path + '/' + file,
      }

      return this.resource.getUrlUpload({}, param).then((response: any) => {
          return response.json();
      }, (response: any) => {
          return response.json();
      });
    }
}
